import type { ChartRow } from "../types";
import { columnIndex } from "./_shared";

interface Input {
  category: string;
  value: string;
}

export function buildDonut(
  input: Input,
  rows: ChartRow[],
  columns: string[],
  _title: string,
  palette: ReadonlyArray<string>,
) {
  const catIdx = columnIndex(columns, input.category);
  const valIdx = columnIndex(columns, input.value);

  const data = rows.map((row) => ({
    name: row[catIdx] == null ? "—" : String(row[catIdx]),
    value: Number(row[valIdx] ?? 0),
  }));

  const FONT =
    '"Inter", "SF Pro Text", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Arial, sans-serif';
  return {
    color: [...palette],
    textStyle: { fontFamily: FONT },
    tooltip: {
      trigger: "item" as const,
      formatter: "{b}: {c} ({d}%)",
      textStyle: { fontFamily: FONT, fontSize: 12, color: "#171717" },
      borderColor: "#e5e7eb",
      backgroundColor: "rgba(255,255,255,0.96)",
      extraCssText: "box-shadow: 0 6px 24px rgba(15,23,42,0.08); border-radius: 10px;",
    },
    legend: {
      orient: "vertical" as const,
      right: 8,
      top: "middle",
      icon: "circle" as const,
      itemWidth: 8,
      itemHeight: 8,
      textStyle: { fontSize: 12, color: "#404040", fontFamily: FONT },
    },
    series: [
      {
        type: "pie" as const,
        radius: ["52%", "76%"],
        center: ["38%", "55%"],
        avoidLabelOverlap: true,
        label: { show: false },
        labelLine: { show: false },
        itemStyle: { borderColor: "#fff", borderWidth: 2 },
        data,
      },
    ],
  };
}
